/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UploadCvRequestDto } from '../models';
// @ts-ignore
import type { UploadCvResponseDto } from '../models';
// @ts-ignore
import type { UploadCvZipRequestDto } from '../models';
/**
 * ProcessesCvRestApi - axios parameter creator
 */
export const ProcessesCvRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload CV for a recruitment process
         * @param {string} processId 
         * @param {UploadCvRequestDto} uploadCvRequestDto CV details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCv: async (processId: string, uploadCvRequestDto: UploadCvRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('uploadCv', 'processId', processId)
            // verify required parameter 'uploadCvRequestDto' is not null or undefined
            assertParamExists('uploadCv', 'uploadCvRequestDto', uploadCvRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/upload-cv`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCvRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a ZIP archive with CVs for a recruitment process
         * @param {string} processId 
         * @param {UploadCvZipRequestDto} uploadCvZipRequestDto ZIP archive with CV files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCvZip: async (processId: string, uploadCvZipRequestDto: UploadCvZipRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('uploadCvZip', 'processId', processId)
            // verify required parameter 'uploadCvZipRequestDto' is not null or undefined
            assertParamExists('uploadCvZip', 'uploadCvZipRequestDto', uploadCvZipRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/upload-cv-zip`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCvZipRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesCvRestApi - functional programming interface
 */
export const ProcessesCvRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesCvRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Upload CV for a recruitment process
         * @param {string} processId 
         * @param {UploadCvRequestDto} uploadCvRequestDto CV details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCv(processId: string, uploadCvRequestDto: UploadCvRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadCvResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCv(processId, uploadCvRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvRestApi.uploadCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a ZIP archive with CVs for a recruitment process
         * @param {string} processId 
         * @param {UploadCvZipRequestDto} uploadCvZipRequestDto ZIP archive with CV files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCvZip(processId: string, uploadCvZipRequestDto: UploadCvZipRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCvZip(processId, uploadCvZipRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesCvRestApi.uploadCvZip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesCvRestApi - factory interface
 */
export const ProcessesCvRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesCvRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Upload CV for a recruitment process
         * @param {string} processId 
         * @param {UploadCvRequestDto} uploadCvRequestDto CV details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCv(processId: string, uploadCvRequestDto: UploadCvRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UploadCvResponseDto> {
            return localVarFp.uploadCv(processId, uploadCvRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a ZIP archive with CVs for a recruitment process
         * @param {string} processId 
         * @param {UploadCvZipRequestDto} uploadCvZipRequestDto ZIP archive with CV files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCvZip(processId: string, uploadCvZipRequestDto: UploadCvZipRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCvZip(processId, uploadCvZipRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesCvRestApi - interface
 */
export interface ProcessesCvRestApiInterface {
    /**
     * 
     * @summary Upload CV for a recruitment process
     * @param {string} processId 
     * @param {UploadCvRequestDto} uploadCvRequestDto CV details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadCv(processId: string, uploadCvRequestDto: UploadCvRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UploadCvResponseDto>;

    /**
     * 
     * @summary Upload a ZIP archive with CVs for a recruitment process
     * @param {string} processId 
     * @param {UploadCvZipRequestDto} uploadCvZipRequestDto ZIP archive with CV files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadCvZip(processId: string, uploadCvZipRequestDto: UploadCvZipRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesCvRestApi - object-oriented interface
 */
export class ProcessesCvRestApi extends BaseAPI implements ProcessesCvRestApiInterface {
    /**
     * 
     * @summary Upload CV for a recruitment process
     * @param {string} processId 
     * @param {UploadCvRequestDto} uploadCvRequestDto CV details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadCv(processId: string, uploadCvRequestDto: UploadCvRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvRestApiFp(this.configuration).uploadCv(processId, uploadCvRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a ZIP archive with CVs for a recruitment process
     * @param {string} processId 
     * @param {UploadCvZipRequestDto} uploadCvZipRequestDto ZIP archive with CV files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadCvZip(processId: string, uploadCvZipRequestDto: UploadCvZipRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesCvRestApiFp(this.configuration).uploadCvZip(processId, uploadCvZipRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

